import { action, createRequestTypes } from './base';

export const trackerActionTypes = {
  TRACK_ACTION: createRequestTypes('TRACK_ACTION'),
  IDENTIFY_ACTION: createRequestTypes('IDENTIFY_ACTION'),
  PAGE_ACTION: createRequestTypes('PAGE_ACTION'),
};

/**
 *
 */
class TrackerActions {
    /**
     * @param actionType
     * @param {*} data
     * @param isError
     * @return
     */
    trackAction = (actionType, data) => action(trackerActionTypes.TRACK_ACTION.REQUEST, {
      actionType, data,
    })

    /**
     * @param actionType
     * @param {*} data
     * @param isError
     * @return
     */
    identifyAction = () => action(trackerActionTypes.IDENTIFY_ACTION.REQUEST, {})

    /**
     * @param actionType
     * @param {*} data
     * @param page
     * @param isError
     * @return
     */
    pageAction = (page) => action(trackerActionTypes.PAGE_ACTION.REQUEST, {
      page,
    })
}

export default new TrackerActions();
